declare var swal: any;
import { Component, OnInit } from '@angular/core';
import { AppData } from '../../../models/appdata';
import { ApiResponseModel } from '../../../models/api_response_model';
import { ActorService } from '../../../services/actor.service';
import * as alertFunctions from '../../../../shared/data/sweet-alerts';
import { CustomDateTimeService } from '../../../services/datetime.service';
import { DoctorsListController, DoctorAppointmentsByDoctorcodeContoller, DoctorAppointmentsByDoctorCodeRequest, AppointmentDetailsByAppointmentCodeRequest, AppointmentDetailsByAppointmentCodeController, SavePatientVisitRequest } from '../../../../../../src/app/ncs/models/actor/actor';
import { DoctorsListRequest } from '../../../../../../src/app/ncs/models/actor/actor';
import { SpinnerService } from '../../../../../../src/app/ncs/services/spinner.service';
import { DoctorListPipe, PatientListPipe } from '../../../../../../src/app/ncs/pipes/actors/actorIdentity.pipes';
import { windowTime } from 'rxjs/operators';
import { NGXToastrService } from '../../../../../../src/app/shared/services/toastr.service';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.css']
})
export class CalendarComponent implements OnInit {

  public ApiResData: ApiResponseModel;
  public isRequesting: boolean = false;
  public DoctorsList: boolean = true;
  public SelectedDoctor: boolean = false;
  public SelectedPatient: boolean = false; 
  public Checkin: boolean = false;
  public Encstart: boolean = false;
  public Encend: boolean = false;
  public Checkout: boolean = false;
  CurrentTime: any;
  ChekIn: NgbDateStruct;




  constructor(private actorservice: ActorService,
    private loaderService: SpinnerService,
    private filter: DoctorListPipe,
    private filter1: PatientListPipe,
    private tosterservice: NGXToastrService,
    private parserFormatter: NgbDateParserFormatter
  ) {
    setInterval(() => {
      this.CurrentTime = new Date().getHours() + ':' + new Date().getMinutes() + ':'+ new Date().getSeconds()


    }, 1
    );
  }

  ngOnInit() {

  
  }

  patientdatails() {
    this.DoctorsList = true;
    this.SelectedDoctor = true;
    this.SelectedPatient = true;
  }
  slotdetails() {
    this.DoctorsList = true;
    this.SelectedDoctor = true;
    
  }

  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
  //pdata: any[];
  //listFilter: string;
  //ngOnChanges(changes: any) {
  //  if (JSON.stringify(changes).indexOf("data") != -1)
  //    this.pdata = this.CurrentDoctorsListController;

  //  this.criteriaChange(this.listFilter);
  //}
  //criteriaChange(value: any) {
  //  if (this.filter != null) {
  //    if (value != '[object Event]') {
  //      this.listFilter = value;
  //      //alert(this.listFilter);
  //      this.pdata = this.filter.transform(this.CurrentDoctorsListController, this.listFilter);
  //    }
  //  }
  //}

  //pdata1: any[];
  //listFilter1: string;
  //ngOnChanges1(changes: any) {
  //  if (JSON.stringify(changes).indexOf("data") != -1)
  //    this.pdata1 = this.CurrentDoctorAppointmentsByDoctorcodeController;

  //  this.criteriaChange1(this.listFilter1);
  //}
  //criteriaChange1(value: any) {
  //  if (this.filter1 != null) {
  //    if (value != '[object Event]') {
  //      this.listFilter1 = value;
  //      //alert(this.listFilter);
  //      this.pdata1 = this.filter1.transform(this.CurrentDoctorAppointmentsByDoctorcodeController, this.listFilter1);
  //    }
  //  }
  //}
}
